import { DataContextProvider } from 'app/context/data';
import { DataBindings } from 'app/context/data/types';
import { ResourceProvider } from 'app/context/resource';
import { ResourceProps } from 'app/context/resource/types';
import React, { PropsWithChildren } from 'react';

type Props = {
  resources?: ResourceProps[];
  dataProvider: DataBindings;
};

const AppContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  resources,
  dataProvider
}) => {
  return (
    <DataContextProvider dataProvider={dataProvider}>
      <ResourceProvider resources={resources ?? []}>
        {children}
      </ResourceProvider>
    </DataContextProvider>
  );
};
export default AppContainer;
